/*
 * Public API Surface of ng-animate
 */

export * from './lib/attention-seekers';
export * from './lib/bouncing';
export * from './lib/fading';
export * from './lib/flippers';
export * from './lib/lightspeed';
export * from './lib/rotate';
export * from './lib/specials';
export * from './lib/zooming';
export * from './lib/back';
